'use strict';

exports.__esModule = true;

var _logSession = require('./log.session.identity');

var _logSession2 = _interopRequireDefault(_logSession);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _UrlUtility = require('../UrlUtility');

var _UrlUtility2 = _interopRequireDefault(_UrlUtility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Model Factory class instance to enforce defined
 * structure for logs - ideally each defined model
 * would either be added, or would extend this class
 * to standardize the logging format across applications
 */
var logModelFactory = function () {

    /**
     * Log Model Factory Instantiation
     * @param scriptName {string}
     * @param sessionIdentity {logSessionIdentity}
     * @returns {logModelFactory}
     */
    function logModelFactory(scriptName, sessionIdentity) {
        _classCallCheck(this, logModelFactory);

        if (!!!scriptName) throw 'log name required for instantiation';

        if (!!!sessionIdentity || !sessionIdentity instanceof _logSession2.default) throw 'logSessionIdentity instance required for instantiation';

        this.sessionIdentity = sessionIdentity;
        this.view = scriptName;
    }

    /**
     * Standard Model for logging object
     * @param logContext {object}
     * @returns {object}
     */


    logModelFactory.prototype.model = function model(logContext) {
        return _lodash2.default.merge({
            view: this.view,
            payload: logContext
        }, this.mapSessionIdentity());
    };

    /**
     *  Standard Model for logging object with comment property
     * @param logContext {object}
     * @param comment {string}
     * @returns {object}
     */


    logModelFactory.prototype.modelCommented = function modelCommented(logContext, comment) {
        return _lodash2.default.merge({
            view: this.view,
            comment: comment,
            payload: logContext
        }, this.mapSessionIdentity());
    };

    /**
     * Model for logging with method property
     * @param methodName {string}
     * @param logContext {object}
     * @returns {object}
     */


    logModelFactory.prototype.methodModel = function methodModel(methodName, logContext) {
        return _lodash2.default.merge({}, {
            view: this.view,
            method: methodName,
            payload: logContext
        }, this.mapSessionIdentity());
    };

    /**
     * Model for logging with method and comment properties
     * @param methodName {string}
     * @param logContext {object}
     * @param comment {string}
     * @returns {object}
     */


    logModelFactory.prototype.methodModelCommented = function methodModelCommented(methodName, logContext, comment) {
        return _lodash2.default.merge({}, {
            view: this.view,
            method: methodName,
            comment: comment,
            payload: logContext
        }, this.mapSessionIdentity());
    };

    logModelFactory.prototype.reqModel = function reqModel(methodName, payload) {
        return this.methodModel(methodName, {
            req: {
                headers: payload.headers,
                method: payload.method,
                body: payload.body,
                queryString: payload.queryString,
                url: payload.url
            }
        });
    };

    logModelFactory.prototype.resModel = function resModel(methodName, payload) {
        var req = payload.req || {};
        return this.methodModel(methodName, {
            res: {
                headers: payload.headers,
                serviceStatus: payload.body.serviceStatus,
                serviceMessages: payload.body.serviceMessages ? payload.body.serviceMessages : [],
                statusCode: payload.status,
                statusText: payload.statusText,
                metrics: payload.metrics || {}
            },
            req: {
                headers: req.headers,
                method: req.method,
                body: req.body,
                queryString: req.queryString,
                uri: _UrlUtility2.default.deconstructUrl(req.url)
            }
        });
    };

    logModelFactory.prototype.mapSessionIdentity = function mapSessionIdentity() {
        var sessionIdentifier = {
            sessionTimeStamp: this.sessionIdentity.sessionTimeStamp
        };

        if (this.sessionIdentity.deviceId !== this.sessionIdentity.emptyGuid) sessionIdentifier.deviceId = this.sessionIdentity.deviceId;

        if (this.sessionIdentity.token !== this.sessionIdentity.emptyGuid) sessionIdentifier.token = this.sessionIdentity.token;

        return sessionIdentifier;
    };

    return logModelFactory;
}();

exports.default = logModelFactory;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/elk/log.model.factory.js
// module id = 894
// module chunks = 0